/// <amd-module name="ExtensionManagement/ManagementHub/ExtensionManagementBreadcrumbService" />

import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";

import { IBreadcrumbItemService } from "VSS/Features/PlatformUI/ContributedBreadcrumb";

import { Services, VssService } from "VSS/Platform/Context";

import { IBreadcrumbItem } from "VSSUI/Breadcrumb.Types";

/**
 * Class that updates breadcrumbs with extension management page's selected tab name
 */
export class ExtensionManagementBreadcrumbService extends VssService implements IBreadcrumbItemService {
    private items = new ObservableArray<IBreadcrumbItem>();

    public getBreadcrumbItems(breadcrumbId: string): IReadonlyObservableArray<IBreadcrumbItem> {
        return this.items;
    }

    public setSelectedTabBreadcrumb(name: string) {
        this.items.value = [
            {
                key: "selectedTab",
                text: name,
                rank: 60
            }
        ];
    }
}

Services.add("extension-management-hub-breadcrumb-service", { serviceFactory: ExtensionManagementBreadcrumbService });
